import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getDeptMngList({ searchParams, currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			deptCd: searchParams.deptCd,
			deptNm: searchParams.deptNm,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/comm/qmsbase/deptMng/v1/dept${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
